export class PriceService {
  static format(price, currencySymbol) {
    return `${currencySymbol}${price}`;
  }

  static getFormattedPrimaryServicePrice(primaryService, currencySymbol) {
    const { price, priceInfo } = primaryService;
    if (priceInfo) return priceInfo;
    return price && price > 0 ? this.format(price, currencySymbol) : '';
  }

  static getFormattedOptionPrice(option, currencySymbol) {
    return option && option.price && option.price > 0
      ? currencySymbol
        ? this.format(option.price, currencySymbol)
        : ''
      : option.priceInfo;
  }
}
